import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import accessToken from "./accessToken";
import { TOKEN_LOCALSTORAGE_KEY, USER_LOCALSTORAGE_KEY } from "../const";

// В dev режиме используется прокси, в production - __API__ или origin
export const API_URL = __API__ || "";

export const baseQuery = async (args: any, api: any, extraOptions: any) => {
  const query = await fetchBaseQuery({
    baseUrl: API_URL,
    prepareHeaders: (headers) => {
      const token = accessToken();
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      headers.set("accept", "application/json");
      return headers;
    },
  })(args, api, extraOptions);

  if (query.error?.status === 401) {
    localStorage.removeItem(USER_LOCALSTORAGE_KEY);
    localStorage.removeItem(TOKEN_LOCALSTORAGE_KEY);
    window.location.replace(`${window.location.origin}/`);
  }

  if (query.data && query.meta?.response && Array.isArray(query.data)) {
    const response = query.meta.response as Response;
    const paginationHeaders = {
      "x-current-page": response.headers.get("x-current-page"),
      "x-last-page": response.headers.get("x-last-page"),
      "x-per-page": response.headers.get("x-per-page"),
      "x-total-count": response.headers.get("x-total-count"),
    };

    if (paginationHeaders["x-current-page"]) {
      query.data = {
        data: query.data,
        meta: {
          currentPage: Number(paginationHeaders["x-current-page"]) || 1,
          lastPage: Number(paginationHeaders["x-last-page"]) || 1,
          perPage: Number(paginationHeaders["x-per-page"]) || 10,
          total: Number(paginationHeaders["x-total-count"]) || 0,
        },
      } as any;
    }
  }

  return query;
};

export const baseApi = createApi({
  reducerPath: "api",
  baseQuery,
  tagTypes: [
    "User",
    "Courses",
    "Course",
    "Sections",
    "Lessons",
    "Lesson",
    "Tasks",
    "Users-list",
    "User-list",
    "Coupons",
    "Coupon",
    "Words-list",
    "Word",
    "Transactions-list",
    "Rewards",
    "Reward",
    "Domain-tags",
    "KoalaPhrases",
    "KoalaPhrase",
    "Notifications",
    "Notification",
    "Word-packs",
    "Word-pack",
    "Course-invites",
  ],
  endpoints: () => ({}),
});
